
import React, { Component, Fragment } from 'react';
import { Button, message, DatePicker } from 'antd';
import CpSteps from '../../components/CpSteps';
import CpAddressModal from '../../components/CpAddressModal';
import CpProductInfo from '../../components/CpProductInfo';
import CpLoading from '../../components/CpLoading';
import cpSelected from '../../assets/cp-selected.png';
import send from '../../util/request';
import { dateFormat, amountToString } from '../../util/tool';
import cpLogoImg from '../../assets/cp-logo.png';
import { inventoryCreateOrder, inventoryOrderConfirm } from './api';
import { DownOutlined, UpOutlined, PlusOutlined } from '@ant-design/icons';
import { accAdd } from '../../util/math';
import { currency } from '../quotationProduct/formatNumber';
import moment from 'moment';
import './style.less';

const arrival_type_config = {
  '1': '',// 次日达
  '2': '隔日达',
};

const tomorrow = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
const the_day_after_tomorrow = moment(new Date()).add(2, 'days').format('YYYY-MM-DD');

const { localStorage } = window;

const stepConfig = {
  '1': [
    { name: '我的订货单', status: 2 },
    { name: '核对订货单信息', status: 1 },
    { name: '成功提交订货单', status: 0 }
  ],
  '2': [
    { name: '我的计划单', status: 2 },
    { name: '核对计划单信息', status: 1 },
    { name: '成功提交计划单', status: 0 }
  ],
  '3': [//cpm CPM销售订货清单
    { name: '我的订货单', status: 2 },
    { name: '核对订货单信息', status: 1 },
    { name: '成功提交订货单', status: 0 }
  ],
};

export default class ProposalSubmit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shopList: [],
      addressList: [],
      currentAddress: {},
      otherAddressList: [],
      addressIsFold: true,
      currentSupplierId: 0,
      currentArrivalType: 0,
      addressModalVisible: false,
      loading: true,
      submitLock: false,
      abroad_transport_type: undefined,
      domestic_transport_type: undefined,
      totalPrice: 0
    };

    this.record = {};
    const params = new URLSearchParams(this.props.location.search);
    this.type = +params.get('type');
    this.addressId = +params.get('addressId');
    this.columns = [
      { key: 'product', name: '商品信息', align: 'left' },
      // { key: 'norms_price', name: '单价', align: 'center', color: '#D60505' },
      // { key: 'arrival_type', name: '到货类型', align: 'center', color: '#D60505' },
      { name: '最新售价', key: 'latest_sale_cost', width: '10%', align: 'center', },
      { name: '最新成本', key: 'latest_cost', width: '10%', align: 'center', },
      { name: '昨日销量', key: 'yesterday_sale_number', width: '10%', align: 'center', },
      { name: '昨日订货量', key: 'yesterday_purchase_number', width: '10%', align: 'center', },
      // { key: 'tax_rate', name: '税率', align: 'right' },
      // { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'right' },
      { key: 'number', name: '数量', align: 'center' },
      // { key: 'real_number', name: '实际订货数量', align: 'center' },
      // { key: 'tax_inclusive_subtotal', name: '小计', align: 'right', color: '#D60505' },
    ];
    this.columnsForPlan = [
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'norms_price', name: '单价', align: 'center', color: '#D60505' },
      { key: 'number', name: '数量', align: 'right', },
    ];
  }
  componentDidMount() {
    try {
      this.requestAddressList();
      this.requestProductList();
    } catch (error) {
      console.log("🚀 ~ file: SubmitOrder.js ~ line 62 ~ SubmitOrder ~ componentDidMount ~ error", error);
    } finally {
      this.setState({ loading: false });
    }
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestProductList = async () => {
    const dataStr = localStorage.getItem('orderData');
    const formatData = JSON.parse(dataStr);
    const { data: { data = {}, msg, code } } = await inventoryOrderConfirm({ order_data: formatData });
    if (+code === 0) {
      let { order_data: shopList = [] } = data;
      let totalCount = 0, totalPrice = 0, totalSku = 0;
      for (const item of shopList) {
        // if (this.type === 1) {
        // item.arriveTime = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
        // item.expected_time = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
        // }
        const { sale_list = [] } = item;
        for (const sItem of sale_list) {
          totalSku++;
          const { number = 0, norms_price = 0 } = sItem;
          totalCount = accAdd(totalCount, number);
          totalPrice = accAdd(totalPrice, (number * norms_price || 0));
        }
      }

      if (this.type === 1) {
        shopList = shopList.reduce((pre, cur) => {
          let { sale_list = [], ...res } = cur;
          return [...pre, { ...res, arrival_type: '1', arriveTime: tomorrow, expected_time: tomorrow, sale_list: sale_list.filter(s => `${s.arrival_type}` === '1') }, { ...res, arrival_type: '2', arriveTime: the_day_after_tomorrow, expected_time: the_day_after_tomorrow, sale_list: sale_list.filter(s => `${s.arrival_type}` === '2') }];
        }, []).filter(item => !!item.sale_list.length);
      }


      this.setState({ shopList, totalCount, totalSku, totalPrice: currency(totalPrice.toFixed(2)) });
    } else {
      message.error(msg);
    }
  }
  requestAddressList = () => {
    send({
      url: '/ipp/user-address/select',
      method: 'GET',
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { list = [] } = res.data.data;
        let data = [];
        list.forEach((item) => {
          data.push({
            ...item,
            id: item.id,
            userId: item.user_id,
            username: item.username,
            phone: item.phone,
            countryId: item.country_id,
            countryName: item.country_name,
            provinceId: item.province_id,
            provinceName: item.province_name,
            areaId: item.area_id,
            areaName: item.area_name,
            cityId: item.city_id,
            cityName: item.city_name,
            address: item.address,
            postalCode: item.postal_code,
            isDefault: item.is_default,
            createTime: item.create_time,
            updateTime: item.update_time,
          });
        });

        // 默认地址放到第一位
        data.sort((a, b) => {
          return b.isDefault - a.isDefault;
        });
        let others = data.slice(1);
        this.setState({
          addressList: data,
          currentAddress: data[0],
          otherAddressList: others,
        });
      }
    });
  }

  moreBtnClicked = () => {
    this.setState({
      addressIsFold: !this.state.addressIsFold
    });
  }

  selectAddress = (addressId) => {
    let currentAddress = {};
    let otherAddressList = [];
    this.state.addressList.forEach(obj => {
      if (Number(obj.id) === Number(addressId)) {
        currentAddress = obj;
      } else {
        otherAddressList.push(obj);
      }
    });
    this.setState({
      addressIsFold: true,
      currentAddress,
      otherAddressList
    });
  }

  toSubmitOrder = async () => {
    try {
      const { currentAddress, shopList } = this.state;
      if (!currentAddress || !currentAddress.id) {
        message.info('请先选择收货地址', 2);
        return;
      }
      const filter_shop_list = shopList.filter(item => !item.expected_time);
      if (filter_shop_list.length) {
        message.info('请先选择到货时间', 2);
        return;
      }
      if (this.state.submitLock) { return; }
      this.setState({ submitLock: true });
      const { data: { msg, code } } = await inventoryCreateOrder({ order_data: shopList, address_id: currentAddress.id });
      if (+code === 0) {
        localStorage.removeItem('select_rows_cache');
        this.props.history.push('/basic/submit/3/result');
      } else {
        message.error(msg);
        this.setState({ submitLock: false });
      }
    } finally {
      this.setState({ submitLock: false });
    }
  }

  changeTime = (supplierId, arrival_type) => {
    let index = arrival_type ? this.state.shopList.findIndex(obj => obj.supplier_id === supplierId && obj.arrival_type === arrival_type) : this.state.shopList.findIndex(obj => obj.supplier_id === supplierId);
    if (index !== -1) {
      let shopList = this.state.shopList;
      shopList[index].arriveTime = dateFormat(new Date(), 'yyyy-MM-dd');
      this.setState({
        shopList,
        currentSupplierId: supplierId,
        currentArrivalType: arrival_type,
        showDatePicker: true
      });
    }
  }

  dateChanged = (moment, date) => {
    this.setState({
      showDatePicker: false
    });
    const index = this.state.currentArrivalType ? this.state.shopList.findIndex(obj => obj.supplier_id === this.state.currentSupplierId && obj.arrival_type === this.state.currentArrivalType) : this.state.shopList.findIndex(obj => obj.supplier_id === this.state.currentSupplierId);
    if (index !== -1) {
      const shopList = this.state.shopList;
      shopList[index].expected_time = date;
      this.setState({
        shopList
      });
    }
  }

  addNewAddress = () => {
    this.setState({
      addressModalVisible: true,
    });
    this.record = {};
  }

  editAddress = () => {
    this.record = this.state.currentAddress;
    this.setState({
      addressModalVisible: true,
    });
  }

  hideModal = () => {
    this.setState({
      addressModalVisible: false
    });
    this.record = {};
  }
  submitModal = () => {
    this.setState({
      addressModalVisible: false
    });
    this.record = {};
    this.requestAddressList();
  }
  toProductDetail = (product) => {
    // return false;
    // const { spu_id, supplier_id, norms_id } = product;
    // if (!spu_id || !supplier_id || !norms_id) {
    //   message.info('商品缺少spu_id或norms_id或supplier_id', 2);
    //   return;
    // }
    // this.props.history.push('/basic/product/detail/' + spu_id + '/' + supplier_id + '/' + norms_id);
  }
  render() {
    const { shopList, totalCount, totalSku, totalPrice, addressList, addressIsFold, currentAddress, otherAddressList, showDatePicker, currentSupplierId, addressModalVisible, loading, submitLock, currentArrivalType } = this.state;
    // const { shopList, totalCount, totalPrice, addressList, addressIsFold, currentAddress, otherAddressList, addressModalVisible, loading, submitLock } = this.state;
    const type = this.type || 1;
    let stepArray = stepConfig[type];
    let columns = type === 1 ? this.columns : this.columnsForPlan;

    let header = (
      <div className="submit-order-top">
        <img style={{ width: 132, height: 60 }} src={cpLogoImg} alt="" />
        <div className="steps">
          <CpSteps current={1} steps={stepArray} />
        </div>
      </div>
    );

    let addressItem = (item) => {
      return (
        (!item || !item.id) ? null : (
          <div>
            <span>{item.username}</span>
            <span style={{ marginLeft: '20px' }}>{item.provinceName + item.cityName + item.areaName + item.address}</span>
            <span style={{ marginLeft: '20px' }}>{item.phone}</span>
          </div>
        )
      );
    };

    function disabledDate(current) {
      return current && current < moment().subtract(1, "days"); //当天之前的不可选，不包括当天
    }

    return (
      <div className="submit-order">
        {loading ? <CpLoading size="large" className="cp-loading" /> : null}
        {header}
        <div className="address-info">
          <div className="address-title">收货信息</div>
          <div className="address-list">
            <div className="left">
              {
                addressList.length <= 0 && (
                  <div className="empty-address">
                    <Button className="empty-address-btn" icon={<PlusOutlined />} onClick={this.addNewAddress}>添加地址</Button>
                  </div>
                )
              }
              {
                addressList.length > 0 && (
                  <Fragment>
                    <div className="default-address">
                      <div className="address-item">
                        {addressItem(currentAddress)}
                        <span className='pointer' onClick={this.editAddress}>编辑</span>
                        <img className="cp-selected-icon" src={cpSelected} alt=""></img>
                      </div>
                    </div>
                    {
                      !addressIsFold && (
                        <div className="other-address">
                          {
                            otherAddressList.map((item, index) => {
                              return (
                                <div key={index} className="address-item other" onClick={() => { this.selectAddress(item.id); }}>
                                  {addressItem(item)}
                                </div>
                              );
                            })
                          }
                        </div>
                      )
                    }
                    {
                      addressList.length > 1 && (
                        <Button className="address-more" onClick={this.moreBtnClicked}>
                          {
                            addressIsFold ? '更多地址' : '收起更多地址'
                          }
                          {
                            addressIsFold ? <DownOutlined style={{ marginLeft: '10px' }} /> : <UpOutlined style={{ marginLeft: '10px' }} />
                          }
                        </Button>
                      )
                    }
                  </Fragment>
                )
              }
            </div>
            <span className='pointer' onClick={this.addNewAddress}>新增收货地址</span>
          </div>
        </div>

        <div className="product-info">
          <div className="product-title">送货清单</div>
          <div className="product-list">
            <table className="cp-table">
              <thead>
                <tr>
                  {
                    columns.map((item, index) => {
                      return (
                        <th key={index} style={{ textAlign: item.align }}>
                          {item.name}
                        </th>
                      );
                    })
                  }
                </tr>
              </thead>
              <tbody>
                {
                  shopList.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        <tr>
                          {
                            +this.type === 1 ? <Fragment>
                              {/* <td colSpan={(columns.length) / 2} className="td-group"> */}
                              <td colSpan={(columns.length) - 1} className="td-group">
                                供应商：{item.supplier_name}
                              </td>
                              <td colSpan={1} className="td-group group-item">
                                <span>{type === 1 ? '期望到货时间：' : '期望到货时间：'}</span>
                                {/* <Typography.Link>{item.expected_time}</Typography.Link> */}
                                {
                                  item.arriveTime && item?.arriveTime?.length && (
                                    <DatePicker
                                      bordered={false}
                                      allowClear={false}
                                      placeholder=""
                                      suffixIcon={false}
                                      defaultValue={item.arriveTime ? moment(item.arriveTime) : null}
                                      disabledDate={disabledDate}
                                      onClick={() => { this.changeTime(item?.supplier_id, item?.arrival_type); }}
                                      open={showDatePicker && (currentArrivalType ? (item.supplier_id === currentSupplierId && item.arrival_type === currentArrivalType) : (item.supplier_id === currentSupplierId))}
                                      onChange={this.dateChanged}
                                    />
                                  )
                                }
                                {
                                }
                                <span className='pointer' style={{ color: 'blue' }} onClick={() => { this.changeTime(item?.supplier_id, item?.arrival_type); }}>{item?.arriveTime?.length ? '修改' : '选择'}</span>
                              </td>
                            </Fragment> : null
                          }
                          {
                            +this.type === 3 ? <Fragment>
                              <td colSpan={(columns.length)} className="td-group" >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span>供应商：{item.supplier_name}</span>
                                  <span>期望到货时间：<span style={{ color: '#D60505' }}>{item.expected_time}</span></span>
                                </div>
                              </td>
                              {/* <td colSpan={(columns.length) / 2} className="td-group group-item">
                                <span>{type === 1 ? '期望到货时间：' : '期望到货时间：'}</span>
                                <Typography.Link>{item.expected_time}</Typography.Link>
                                {
                                  item.arriveTime && item?.arriveTime?.length && (
                                    <DatePicker
                                      bordered={false}
                                      allowClear={false}
                                      placeholder=""
                                      suffixIcon={false}
                                      disabledDate={disabledDate}
                                      open={showDatePicker && item.supplierId === currentSupplierId}
                                      onChange={this.dateChanged}
                                    />
                                  )
                                }
                                <span className='pointer' style={{ color: 'blue' }} onClick={() => { this.changeTime(item?.supplierId); }}>{item?.arriveTime?.length ? '修改' : '选择'}</span>
                              </td> */}
                            </Fragment> : null
                          }
                        </tr>
                        {
                          (item.sale_list || []).map((p, idx) => {
                            return (
                              <tr key={idx}>
                                {
                                  columns.map((col, i) => {
                                    if (col.key === 'product') {
                                      return (
                                        <td key={i} style={{width: '30%'}}>
                                          <div className="p-info">
                                            <CpProductInfo product={{ ...p, sale_norms: p.sale_unit, mapping: {out_sku_no: p.out_sku_no} }} toProductDetail={() => { this.toProductDetail(p); }} />
                                          </div>
                                        </td>
                                      );
                                    } else if (col.key === 'number') {
                                      return (
                                        <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>
                                          <div>{p.number} {p.sale_unit}</div>
                                          {p.out_prop > 1 ? <div>{+((p.number * p.out_prop).toFixed(3))} {p.out_unit}</div> : null}
                                        </td>
                                      );
                                    } else if (col.key === 'norms_price') {
                                      return (
                                        <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>
                                          ¥{p.norms_price}
                                        </td>
                                      );
                                    } else if (col.key === 'yesterday_purchase_number') {
                                      const { yesterday_purchase_number, out_prop, out_unit, sale_unit } = p;
                                      return <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color, width: col.width }}>
                                        {yesterday_purchase_number > 0 ? <div className='proposal-cart-table-stock' >
                                          <div>{yesterday_purchase_number} {sale_unit}</div>
                                          {out_prop > 1 ? <div>{+((yesterday_purchase_number * out_prop).toFixed(3))} {out_unit}</div> : null}
                                        </div> : '0'}
                                      </td>;
                                    } else if (col.key === 'latest_sale_cost') {
                                      const { latest_sale_cost, out_prop, out_unit, sale_unit } = p;
                                      return <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color, width: col.width }}>
                                        {latest_sale_cost > 0 ? <div className='proposal-cart-table-stock' >
                                          <div>￥{(latest_sale_cost * out_prop).toFixed(2)} / {sale_unit}</div>
                                          {out_prop > 1 ? <div>￥{latest_sale_cost.toFixed(2)} / {out_unit}</div> : null}
                                        </div> : '-'}
                                      </td>;
                                    } else if (col.key === 'latest_cost') {
                                      const { latest_cost, out_prop, out_unit, sale_unit } = p;
                                      return <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color, width: col.width }}>
                                        {latest_cost > 0 ? <div className='proposal-cart-table-stock' >
                                          <div>￥{(latest_cost * out_prop).toFixed(2)} / {sale_unit}</div>
                                          {out_prop > 1 ? <div>￥{latest_cost.toFixed(2)} / {out_unit}</div> : null}
                                        </div> : '-'}
                                      </td>;
                                    } else if (col.key === 'yesterday_sale_number') {
                                      const { yesterday_sale_number, out_prop, out_unit, sale_unit } = p;
                                      return <td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color, width: col.width }}>
                                        {yesterday_sale_number > 0 ? <div className='proposal-cart-table-stock' >
                                          <div>{Math.ceil(yesterday_sale_number / out_prop)} {sale_unit}</div>
                                          {out_prop > 1 ? <div>{yesterday_sale_number} {out_unit}</div> : null}
                                        </div> : '-'}
                                      </td>;
                                    } else if (type === 1 && (col.key === 'unit_amount' || col.key === 'tax_inclusive_subtotal')) {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>￥{p[col.key]}</td>);
                                    } else if (type === 1 && (col.key === 'arrival_type')) {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>{arrival_type_config[p[col.key]]}</td>);
                                    } else if (col.key === 'tax_rate') {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>{p[col.key] >= 0 ? (+p[col.key] + '%') : '-'}</td>);
                                    } else if (col.key === 'tax_inclusive_price') {
                                      return (<td key={i} style={{ textAlign: col.align, fontWeight: '600', color: col.color }}>{p.tax_inclusive_price === '-' ? '' : <>￥{amountToString(p.tax_inclusive_price)}</>}</td>);
                                    } else {
                                      return null;
                                    }
                                  })
                                }
                              </tr>
                            );
                          })
                        }
                      </Fragment>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="total-info">
          <div>共<span className="total-count">{totalSku}</span>种（<span className="total-count">{totalCount}</span>）件商品<span hidden={type === 2}>
            ，总价：<span className="total-price">￥{totalPrice}</span>
          </span>
          </div>
          <div style={{ color: 'rgba(0,0,0,0.5)' }}>
            {addressItem(currentAddress)}
          </div>
        </div>
        <div className="bottom">
          <Button className={'return-button'} onClick={() => { window.history.back(); }}>返回</Button>
          <Button className={submitLock ? 'submit-button unactive' : 'submit-button'} onClick={this.toSubmitOrder}>提交订货单</Button>
        </div>
        {
          addressModalVisible && (
            <CpAddressModal
              record={this.record}
              hideModal={this.hideModal}
              submitModal={this.submitModal}>
            </CpAddressModal>
          )
        }
      </div>
    );
  }
}
